import { render, staticRenderFns } from "./kurssikoodi-form.vue?vue&type=template&id=5fc85af8&"
import script from "./kurssikoodi-form.vue?vue&type=script&lang=ts&"
export * from "./kurssikoodi-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports